import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  videoOn: true,
  audioOn: true,
};

const videoSlice = createSlice({
  name: "video",
  initialState,
  reducers: {
    toggleVideo: (state) => {
      state.videoOn = !state.videoOn;
    },
    toggleAudio: (state) => {
      state.audioOn = !state.audioOn;
    },
  },
});

export const { toggleVideo, toggleAudio } = videoSlice.actions;
export default videoSlice.reducer;
